export interface MetricQuickPulse {
    Name: string;

    Value: number;

    Weight: number;
}
